import React from "react";

function TrendDown() {
  return (
    <div>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="17"
        height="16"
        viewBox="0 0 17 16"
        fill="none"
      >
        <path
          d="M15.3999 8.00003V12C15.3999 12.1326 15.3473 12.2598 15.2535 12.3536C15.1597 12.4474 15.0325 12.5 14.8999 12.5H10.8999C10.7673 12.5 10.6402 12.4474 10.5464 12.3536C10.4526 12.2598 10.3999 12.1326 10.3999 12C10.3999 11.8674 10.4526 11.7402 10.5464 11.6465C10.6402 11.5527 10.7673 11.5 10.8999 11.5H13.6931L8.89994 6.70691L6.75369 8.85378C6.70725 8.90027 6.65211 8.93715 6.59141 8.96231C6.53071 8.98748 6.46564 9.00043 6.39994 9.00043C6.33423 9.00043 6.26917 8.98748 6.20847 8.96231C6.14777 8.93715 6.09262 8.90027 6.04619 8.85378L1.54619 4.35378C1.45237 4.25996 1.39966 4.13272 1.39966 4.00003C1.39966 3.86735 1.45237 3.7401 1.54619 3.64628C1.64001 3.55246 1.76725 3.49976 1.89994 3.49976C2.03262 3.49976 2.15987 3.55246 2.25369 3.64628L6.39994 7.79316L8.54619 5.64628C8.59262 5.5998 8.64777 5.56292 8.70847 5.53775C8.76917 5.51259 8.83423 5.49964 8.89994 5.49964C8.96564 5.49964 9.03071 5.51259 9.09141 5.53775C9.15211 5.56292 9.20725 5.5998 9.25369 5.64628L14.3999 10.7932V8.00003C14.3999 7.86743 14.4526 7.74025 14.5464 7.64648C14.6402 7.55271 14.7673 7.50003 14.8999 7.50003C15.0325 7.50003 15.1597 7.55271 15.2535 7.64648C15.3473 7.74025 15.3999 7.86743 15.3999 8.00003Z"
          fill="#E03B24"
        />
      </svg>
    </div>
  );
}

export default TrendDown;
